import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { toast } from 'react-toastify';
import { notificationManagers } from '../../../helpers/adipiBackendUrl';
import { getTable, postApiCall } from "../../../services/mainServices";
import {
  ADD_NEW_NOTIFICATIONMANAGER,
  DELETE_NOTIFICATIONMANAGER,
  GET_NOTIFICATIONMANAGER,
  GET_NOTIFICATIONMANAGERS,
  UPDATE_NOTIFICATIONMANAGER,
  UPDATE_NOTIFICATIONMANAGERSTATUS
} from "./actionTypes";
import {
  addNotificationManagerFail,
  addNotificationManagerSuccess,
  deleteNotificationManagerFail,
  deleteNotificationManagerSuccess,
  getNotificationManagerFail,
  getNotificationManagersFail,
  getNotificationManagersSuccess,
  getNotificationManagerSuccess,
  setState,
  updateNotificationManagerFail,
  updateNotificationManagerStatusFail,
  updateNotificationManagerStatusSuccess,
  updateNotificationManagerSuccess,
} from "./actions";
//Include Both Helper File with needed methods

function* fetchNotificationManagers( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable, notificationManagers, params.toString());
    yield put(setState(false))
    yield put(getNotificationManagersSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getNotificationManagersFail(error));
  }
}

function* fetchNotificationManagerById( { payload: { params } } ) {
  try {
    const response = yield call(getTable,notificationManagers, params.toString());
    yield put(getNotificationManagerSuccess(response));
  } catch (error) {
    yield put(getNotificationManagerFail(error));
  }
}

function* updateNotificationManager ({payload: notificationManagerObj }) {
  try {
    const response = yield call(getTable,`${notificationManagers}/${notificationManagerObj.id}`);
    yield put(updateNotificationManagerSuccess(response));
    toast.success('Registro actualizado correctamente')
  } catch (error) {
    yield put(updateNotificationManagerFail(error));
    toast.error('Error al actualizar el registro')
  }
}

function* updateNotificationManagerStatus ({payload: notificationManagerObj }) {
  try {
    const response = yield call(getTable,`${notificationManagers}/${notificationManagerObj.id}`);
    yield put(updateNotificationManagerStatusSuccess(response));
    toast.success('Registro actualizado correctamente')
  } catch (error) {
    yield put(updateNotificationManagerStatusFail(error));
    toast.error('Error al actualizar el registro')
  }
}

function* deleteNotificationManager ({payload: notificationManagerObj}) {
  try {
    yield put(deleteNotificationManagerSuccess(notificationManagerObj.id));
    toast.success('Registro borrado correctamente')
  } catch (error) {
    yield put(deleteNotificationManagerFail(error));
    toast.error('Error al borrar el registro')
  }
}

function* postingNotificationManager ({ payload: notificationManager}) {
  try {
    yield put(setState(true))
    const response = yield call(postApiCall, notificationManagers ,notificationManager);
    const response1 = yield call(getTable,`${notificationManagers}/${response.id}`);
    yield put(getNotificationManagerSuccess(response1));
    yield put(addNotificationManagerSuccess(response1));
    toast.success('Registro agregado correctamente')
    yield put(setState(false))
  } catch (error) {
    yield put(addNotificationManagerFail(error));
    toast.error('Error al agregar el registro')
    yield put(setState(false))
  }
}

function* notificationManagersSaga() {
  yield takeEvery(GET_NOTIFICATIONMANAGERS, fetchNotificationManagers);
  yield takeEvery(GET_NOTIFICATIONMANAGER, fetchNotificationManagerById);
  yield takeEvery(ADD_NEW_NOTIFICATIONMANAGER, postingNotificationManager);
  yield takeEvery(UPDATE_NOTIFICATIONMANAGER, updateNotificationManager);
  yield takeEvery(UPDATE_NOTIFICATIONMANAGERSTATUS, updateNotificationManagerStatus);
  yield takeEvery(DELETE_NOTIFICATIONMANAGER, deleteNotificationManager);
}

export default notificationManagersSaga;
